export default __webpack_public_path__ + "static/media/image-empty-bookings.41f2e2e9.svg";